import { useSmartMutation } from "./useSmartMutation";
import { getSavedCRMConfig } from "../apis/crm";
import { useStoreCRMConfig } from "../stores/useStoreCRMConfig";

export const useGetCRMSavedConfig = (onSuccess, onError) => {
  const { savedCRMConfig, setSavedCRMConfig } = useStoreCRMConfig();

  return useSmartMutation("get_crm_objects", getSavedCRMConfig, {
    zustandSetter: { setter: setSavedCRMConfig, path: "data" },
    onSuccess: (data, variables, context) => {
      onSuccess?.(data, variables, context);
    },
    onError,
  });
};
